import api from '../../api/stoTrade'

export default {
  state: {
    orderHistory: [],
    openOrders: [],
  },
  getters: {
    orderHistory(state) {
      return state.orderHistory
    },
    openOrders(state) {
      return state.openOrders
    },
  },
  mutations: {
    SET_ORDER_HISTORY(state, orderHistory) {
      state.orderHistory = orderHistory
    },
    SET_OPEN_ORDERS(state, openOrders) {
      state.openOrders = openOrders
    },
  },
  actions: {
    async fetchOrderHistory({ commit }) {
      try {
        const { data } = await api.orderHistory()
        commit('SET_ORDER_HISTORY', data.data)
      } catch (error) {
        console.log(error)
      }
    },
    async fetchOpenOrders({ commit }) {
      try {
        const { data } = await api.openOrders()
        commit('SET_OPEN_ORDERS', data)
      } catch (error) {
        console.log(error)
      }
    },
  },
}
